var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongScanErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 101,
    viewBox: "0 0 116 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2357 12.0814L54.3459 9.27073L39.1336 0.50054L39.1235 0.508331L0.0078125 23.0643L15.1997 31.828L20.0997 34.6454H20.1065L33.0162 42.0836L36.8854 44.3149L36.8921 44.3281L46.8313 38.5788L75.9603 21.7681L75.9874 21.7512L59.2357 12.0814Z",
    fill: "#FDDA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5367 12.4758L53.6673 9.65873L39.1331 1.27589L1.36719 23.0632L15.969 31.3827L20.8894 34.1866L36.8917 43.3086L74.6238 21.7502L58.5367 12.4758Z",
    fill: "#F7C475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8911 44.3276V46.6066L36.8843 53.7235L36.8471 94.4934L36.8403 94.5V94.4934L19.9902 84.8912L15.0969 82.1004L0 73.4981V23.0637L15.2021 31.8275L20.0987 34.6449L36.8843 44.3144L36.8911 44.3276Z",
    fill: "#B97139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.837 38.5715L36.8878 44.3144V46.6131L36.8845 53.7103L36.8438 94.4934V94.5L36.8505 94.4934L65.3589 78.2172L76.0035 72.1397V21.7676L46.837 38.5715Z",
    fill: "#DBA151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9897 34.7182V84.8906L15.0938 82.0999V31.9079L19.9897 34.7182Z",
    fill: "#956B45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2284 12.075L45.5558 19.9845L40.6625 22.8083L20.1094 34.6458L19.9704 34.7305L15.0703 31.9093L15.206 31.8206L35.7726 19.9845L40.6625 17.1461L54.3554 9.27112L59.2284 12.075Z",
    fill: "#C7AA83"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1302 43.3944L54.2188 53.7109V38.3423L72.1302 28.0112V43.3944Z",
    fill: "#E7E1DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 32.6185L55.9219 40.9922V39.2647L70.4321 30.9083V32.6185Z",
    fill: "#482819"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 35.7124L55.9219 44.082V43.3307L70.4321 34.9638V35.7124Z",
    fill: "#B0ABA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 37.7307L55.9219 46.0977V45.3358L70.4321 36.9794V37.7307Z",
    fill: "#B0ABA6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 39.9103L55.9219 48.2812V47.5154L70.4321 39.1552V39.9103Z",
    fill: "#B0ABA6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4321 41.9313L55.9219 50.2969V49.5391L70.4321 41.1722V41.9313Z",
    fill: "#B0ABA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 48.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0027 68.5012V72.5012M88.0027 76.5012H88.0127M86.2927 63.3612L77.8227 77.5012C77.6481 77.8036 77.5557 78.1465 77.5547 78.4957C77.5537 78.8449 77.6442 79.1883 77.8171 79.4917C77.9901 79.7951 78.2394 80.0479 78.5404 80.225C78.8414 80.4021 79.1835 80.4973 79.5327 80.5012H96.4727C96.8219 80.4973 97.164 80.4021 97.465 80.225C97.766 80.0479 98.0153 79.7951 98.1883 79.4917C98.3612 79.1883 98.4517 78.8449 98.4507 78.4957C98.4497 78.1465 98.3573 77.8036 98.1827 77.5012L89.7127 63.3612C89.5344 63.0673 89.2834 62.8243 88.9839 62.6557C88.6844 62.487 88.3464 62.3984 88.0027 62.3984C87.659 62.3984 87.321 62.487 87.0215 62.6557C86.722 62.8243 86.471 63.0673 86.2927 63.3612Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 48.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongScanErrorIcon);
export default __webpack_public_path__ + "4d76834c36076e998f8cd4328461e698.svg";
export { ForwardRef as ReactComponent };